<template>
  <div>
    <Row type="flex" jus align="middle">
      <table width="100%" class="TB_COLLAPSE">
        <thead>
          <th class="tc" colspan="5">修改密码</th>
        </thead>
        <tbody>
          <tr>
            <th class="tr" width="50%">
              <font class="mr-2">旧密码</font>
            </th>
            <td>
              <Input class="left ml-2" type="password" v-model="oldpass" style="width:200px" />
            </td>
          </tr>
          <tr>
            <th class="tr">
              <font class="mr-2">新密码</font>
            </th>
            <td>
              <Input
                @on-blur="checkpasslength"
                class="left ml-2"
                type="password"
                v-model="newpass"
                style="width:200px"
              />
              <div class="left ml-2" style="line-height:32px" :class="'pc'+color">{{passstrength}}</div>
            </td>
          </tr>
          <tr>
            <th class="tr">
              <font class="mr-2">确认密码</font>
            </th>
            <td>
              <Input
                @on-blur="check"
                class="left ml-2"
                type="password"
                v-model="confirm"
                style="width:200px"
              />
              <div class="left ml-2 pc1" style="line-height:32px">{{error}}</div>
            </td>
          </tr>
          <tr>
            <td colspan="2">
              <Button class="m-10" @click="pwu()" type="primary">储存</Button>
              <br />密码要求说明:
              <br />1.密码长度為8-12位，必须包含最少1个字母及1个数字;
              <br />2.不要使用常用密码，如Aaaa1111,Qqqq1111。
            </td>
          </tr>
        </tbody>
      </table>
    </Row>
  </div>
</template>
<script>
import { mapGetters, mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      color: 0,
      error: "",
      oldpass: "",
      newpass: "",
      confirm: "",
      passstrength: ""
    };
  },
  computed: {
    ...mapGetters(["getmember"])
  },
  methods: {
    check() {
      if (this.newpass != this.confirm) {
        this.error = "新密码与确认密码不一致";
      } else {
        this.error = "";
      }
    },
    checkpasslength() {
      var strongRegex = new RegExp(
        "^(?=.{8,})(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*\\W).*$",
        "g"
      );
      var mediumRegex = new RegExp(
        "^(?=.{7,})(((?=.*[A-Z])(?=.*[a-z]))|((?=.*[A-Z])(?=.*[0-9]))|((?=.*[a-z])(?=.*[0-9]))).*$",
        "g"
      );
      var enoughRegex = new RegExp("(?=.{6,}).*", "g");
      if (false == enoughRegex.test(this.newpass)) {
        this.passstrength = "密码太短";
        this.color = 1;
      } else if (strongRegex.test(this.newpass)) {
        this.passstrength = "密码强度：强";
        this.color = 3;
      } else if (mediumRegex.test(this.newpass)) {
        this.passstrength = "密码强度：中";
        this.color = 2;
      } else {
        this.passstrength = "密码强度：弱";
        this.color = 2;
      }
      return true;
    },
    pwu() {
      var pass = this.newpass;
      var oldpass = this.oldpass;
      var chpass = this.confirm;
     
      if (pass === chpass && pass.length >= 8 && pass.length <= 12) {
        var reg = /^(?=.*[a-zA-Z]).{8,12}$/;
        var reg2 = /^(?=.*[0-9]).{8,12}$/;
        if (reg.test(pass) && reg2.test(pass)) {
          var fixpass = {
            pass:  this.newpass,
            oldpass:  this.oldpass,
            loid: this.getmember.pid,
            mlevel: this.getmember.mlevel
          }
          this.$axios.personalCenter.fixpass(fixpass).then(data => {
            if (data.status == "1") {
              this.$Message.success("已修改");
              this.oldpass = ""
              this.newpass = ""
              this.confirm = ""
            }
          }).catch(error => {
            this.$Message.error("异常错误");
          })
        } else {
          this.$Message.error("密码必须包含最少1个字母及1个数字");
        }
      } else {
        this.$Message.error("密码与密码确认不相符且长度在8~12位");
      }
    }
  }
};
</script>
